export function normalizeSampleRate(raw: number | string | undefined): number {
  if (typeof raw === 'number') {
    if (!Number.isFinite(raw)) return 0
    if (raw <= 0) return 0
    if (raw >= 1) return 1
    return raw
  }

  if (typeof raw === 'string') {
    const parsed = Number(raw)
    if (!Number.isFinite(parsed)) return 0
    if (parsed <= 0) return 0
    if (parsed >= 1) return 1
    return parsed
  }

  return 0
}

export function scrubEvent(event: { request?: { headers?: Record<string, unknown> } }): void {
  const headers = event.request?.headers
  if (!headers) return

  delete headers.authorization
  delete headers.cookie
  delete headers['set-cookie']
  delete headers['x-api-key']
}

export function scrubBreadcrumbData(breadcrumb: { data?: Record<string, unknown> }): void {
  if (!breadcrumb.data) return

  for (const key of Object.keys(breadcrumb.data)) {
    const lowerKey = key.toLowerCase()
    if (
      lowerKey === 'password' ||
      lowerKey === 'token' ||
      lowerKey === 'secret' ||
      lowerKey === 'retrievalsecret' ||
      lowerKey === 'otp' ||
      lowerKey === 'authorization' ||
      lowerKey === 'auth' ||
      lowerKey.endsWith('_token') ||
      lowerKey.endsWith('_secret') ||
      lowerKey.endsWith('_password')
    ) {
      delete breadcrumb.data[key]
    }
  }
}
